import type {
  DesignerAbilityDefinition,
  StrictAbilityDefinition,
} from './AbilityConfigTypes';

export function defineAbilityConfig<T extends DesignerAbilityDefinition>(
  config: StrictAbilityDefinition<T>
): StrictAbilityDefinition<T> {
  return config;
}
